import { render, staticRenderFns } from "./BoxItem.vue?vue&type=template&id=611fd6e6&scoped=true&"
import script from "./BoxItem.vue?vue&type=script&lang=js&"
export * from "./BoxItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxItem.vue?vue&type=style&index=0&id=611fd6e6&prod&scoped=true&lang=css&"
import style1 from "./BoxItem.vue?vue&type=style&index=1&id=611fd6e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611fd6e6",
  null
  
)

export default component.exports